import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import storyBanner from '../../images/bg_story_banner.jpg';
import storyBanner3 from '../../images/bg_story_banner_2.jpg';
import storyBanner2 from '../../images/story-banner/story-banner-Raptor-Training-2.jpg';
import iconStory1 from '../../images/icons/icon_ourstory_1.png';
import iconStory2 from '../../images/icons/icon_ourstory_2_new2.png';
import iconStory3 from '../../images/icons/icon_ourstory_3.png';
import fordLogoWhite from '../../images/fga_logo_white.png';
import { Carousel } from 'react-responsive-carousel';
import { SITE_TITLE } from '../../constants';

const bgStyle = {
  backgroundImage: `url(${storyBanner})`
};

const carouselBgStyle = url => {
  return {
    background: `url(${url}) no-repeat center/cover`
  };
};

const carouselDisplay = (
  { desktop, mobile } // eslint-disable-line
) => (
  <>
    <div
      className='fe-our-story-carousel-item'
      style={carouselBgStyle(desktop)}
    />
    {/* <div className='fe-our-story-carousel-item' style={carouselBgStyle(mobile)} /> */}
  </>
);

class OurStory extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t } = this.props;
    const carouselImages =
    [
      {img_url:
        {
          desktop: storyBanner2,
          mobile: null
        }
      },
      {img_url:
        {
          desktop: storyBanner3,
          mobile: null
        }
      }
    ];

    const notSingle = carouselImages.length > 1;
    return (
      <>
        <Helmet>
          <title>
            {t('ourStory:title')} | {SITE_TITLE}
          </title>
        </Helmet>
        {/* Without Carousel */}
        {/* <div className='fe-hero-container our-story-container'>
          <div className='fe-our-story-banner' style={bgStyle}> */}
            {/* <div className='fe-home-desc-container'>
              <img src={fordLogoWhite} alt='' />
              <p dangerouslySetInnerHTML={{ __html: t('home:expDesc1') }} />
              <p dangerouslySetInnerHTML={{ __html: t('home:expDesc2') }} />
              <p dangerouslySetInnerHTML={{ __html: t('home:expDesc3') }} />
            </div> */}
          {/* </div>
        </div> */}

        {/* With Carousel */}
        <Carousel
          className='fe-our-story-carousel fe-under-header-effect-except-mobile'
          showArrows={notSingle}
          showStatus={false}
          showIndicators={notSingle}
          showThumbs={false}
          infiniteLoop={notSingle}
          autoPlay={notSingle}
          transitionTime={400}
          emulateTouch={notSingle}
          swipeScrollTolerance={5}
          swipeable={true}
          interval={5000}
        >
          {carouselImages.map((image, i) => {
            return (
              <div key={i} className='fe-our-story-carousel-item-container'>
                {carouselDisplay(image.img_url)}
              </div>
            );
          })}
        </Carousel>

        <article className='fe-our-story'>
          <div className='container'>
            <div className='row'>
              <div className='col'>
                <h1 className='fe-heading'>{t('ourStory:title')}</h1>
                <div
                  dangerouslySetInnerHTML={{
                    __html: t('ourStory:description')
                  }}
                  style={{ textAlign: 'left' }}
                />
              </div>
            </div>
          </div>
        </article>
        <div className='fe-our-story-items'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-4'>
                <div className='fe-our-story-item'>
                  <img src={iconStory1} alt='' />
                  <h3>{t('ourStory:elem1Title')}</h3>
                  <p>{t('ourStory:elem1Text')}</p>
                </div>
              </div>
              <div className='col-md-4'>
                <div className='fe-our-story-item'>
                  <img src={iconStory2} alt='' />
                  <h3>{t('ourStory:elem2Title')}</h3>
                  <p>{t('ourStory:elem2Text')}</p>
                </div>
              </div>
              <div className='col-md-4'>
                <div className='fe-our-story-item'>
                  <img src={iconStory3} alt='' />
                  <h3>{t('ourStory:elem3Title')}</h3>
                  <p>{t('ourStory:elem3Text')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

OurStory.propTypes = {
  t: PropTypes.func.isRequired
};

export default withTranslation()(OurStory);
